var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10C0 4.47716 4.47715 0 10 0H108C113.523 0 118 4.47715 118 10V114H0V10Z",
  fill: "#556080",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M91 55C91 72.6733 76.6733 87 59 87C41.3267 87 27 72.6733 27 55C27 37.3267 41.3267 23 59 23C76.6733 23 91 37.3267 91 55Z",
  fill: "#613394"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M65.2881 86.3813C79.8687 83.4756 90.8755 70.6636 90.9966 55.2573L82.0381 46.2988L33.875 54.9678L65.2881 86.3813Z",
  fill: "#4B1B7A"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M82.0381 46.2983L84.125 54.9673C84.125 54.9673 67.2681 57.3755 62.6123 69.5767H55.3877C50.7319 57.3755 33.875 54.9673 33.875 54.9673L35.9619 46.2979L82.0381 46.2983Z",
  fill: "#FF0068"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M82.0381 46.2988H59V69.5771H62.6123C67.2681 57.376 84.125 54.9678 84.125 54.9678L82.0381 46.2988Z",
  fill: "#E50E70"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M71.0547 66.2146L65.9764 58L63.1479 69.365L65.9764 75.3415C69.2771 75.3415 71.9528 72.6657 71.9528 69.365C71.9528 68.2086 71.6235 67.1294 71.0547 66.2146Z",
  fill: "#FFF9D1"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M60.8981 66.2146C60.3294 67.1294 60 68.2086 60 69.365C60 72.6657 62.6758 75.3415 65.9764 75.3415V58L60.8981 66.2146Z",
  fill: "white"
});
function SvgSymptomVaginalDischarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 114,
    viewBox: "0 0 118 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomVaginalDischarge);
export default __webpack_public_path__ + "static/media/symptom-Vaginal-Discharge.1ad61dfe873b7a7a343db2157d9544a9.svg";
export { ForwardRef as ReactComponent };